<template>
  <v-card class="taxa-dialog-card">
    <!-- Header com gradiente -->
    <div class="taxa-dialog-header">
      <v-btn icon class="taxa-close-btn" @click="$emit('fechar')">
        <v-icon color="white">close</v-icon>
      </v-btn>
      <div class="taxa-header-content">
        <v-icon class="taxa-header-icon">monetization_on</v-icon>
        <h1 class="taxa-header-title">Taxa de Serviço</h1>
        <p class="taxa-header-subtitle">Configure as taxas por rede ou aplicativo</p>
      </div>
    </div>

    <v-card-text class="taxa-card-body">
      <v-layout row wrap v-if="!loading && !carregando">
        <!-- Estado vazio -->
        <v-flex xs12 v-if="taxas.length === 0" class="text-xs-center pa-5">
          <v-icon size="64" color="grey lighten-2">receipt_long</v-icon>
          <p class="grey--text mt-3">Nenhuma configuração disponível.</p>
        </v-flex>

        <!-- Cards de taxa -->
        <v-flex xs12 v-for="(taxa, index) in taxas" :key="index">
          <div class="taxa-item-card" :class="{ 'taxa-item-card--active': taxa.ativa }">
            <!-- Cabeçalho do card -->
            <div class="taxa-item-header">
              <div class="taxa-item-header-info">
                <span class="taxa-item-name">
                  {{ taxa.nome_rede === 'Apetrus' ? 'Taxa do Aplicativo Apetrus' : taxa.nome_rede }}
                </span>
              </div>
              <div class="taxa-status-badge" :class="taxa.ativa ? 'taxa-status-badge--on' : 'taxa-status-badge--off'">
                {{ taxa.ativa ? 'Ativa' : 'Inativa' }}
              </div>
            </div>

            <!-- Corpo do card -->
            <div class="taxa-item-body">
              <v-layout row wrap align-center>
                <!-- Switch + Toggle na mesma linha -->
                <v-flex xs12>
                  <div style="display:flex; align-items:center; justify-content:space-between;">
                    <v-switch
                      v-model="taxa.ativa"
                      label="Habilitar taxa de serviço"
                      color="primary"
                      hide-details
                      class="mt-0 pt-0 taxa-switch"
                    ></v-switch>
                    <v-slide-y-transition>
                      <div v-if="taxa.ativa">
                        <div class="taxa-type-toggle" style="display:inline-flex;width:fit-content;flex-shrink:0;">
                          <button
                            class="taxa-type-btn"
                            :class="{ 'taxa-type-btn--active': !taxa.em_percentual }"
                            @click.prevent="taxa.em_percentual = false"
                            style="flex:none;"
                          >R$</button>
                          <button
                            class="taxa-type-btn"
                            :class="{ 'taxa-type-btn--active': taxa.em_percentual }"
                            @click.prevent="taxa.em_percentual = true"
                            style="flex:none;"
                          >%</button>
                        </div>
                      </div>
                    </v-slide-y-transition>
                  </div>
                </v-flex>

                <!-- Campo de valor -->
                <v-flex xs12 class="mt-4" v-if="taxa.ativa">
                  <v-slide-y-transition>
                    <v-text-field
                      v-model.lazy="taxa.valor_formatado"
                      outline
                      v-money="taxa.em_percentual ? moneyPercent : money"
                      :prefix="taxa.em_percentual ? '' : 'R$'"
                      :suffix="taxa.em_percentual ? '%' : ''"
                      :label="`Valor da taxa (${taxa.em_percentual ? '%' : 'R$'})`"
                      hide-details
                      background-color="white"
                      class="taxa-text-field"
                    ></v-text-field>
                  </v-slide-y-transition>
                </v-flex>

                <!-- Tipo de cobrança -->
                <v-flex xs12 class="mt-4" v-if="taxa.ativa">
                  <v-slide-y-transition>
                    <v-select
                      v-model="taxa.tipo_cobranca"
                      :items="[{text: 'Pela Carteira', value: 1}, {text: 'Pelo Posto', value: 2}]"
                      label="Como a taxa será cobrada?"
                      outline
                      hide-details
                      background-color="white"
                      class="taxa-select"
                    >
                      <template slot="append-outer">
                        <v-tooltip bottom>
                          <v-icon slot="activator" color="grey lighten-1" size="20">info_outline</v-icon>
                          <span v-if="taxa.tipo_cobranca === 1">
                            Pela Carteira: O valor é descontado do saldo da carteira virtual do cliente no app e repassado ao admin após a confirmação.
                          </span>
                          <span v-else-if="taxa.tipo_cobranca === 2">
                            Pelo Posto: O valor da taxa é somado ao total da compra e o cliente paga tudo diretamente ao posto.
                          </span>
                          <span v-else>
                            Selecione como a taxa será cobrada do cliente.
                          </span>
                        </v-tooltip>
                      </template>
                    </v-select>
                  </v-slide-y-transition>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </v-flex>

        <!-- Botão salvar -->
        <v-flex xs12 class="mt-4" v-if="taxas.length > 0">
          <button class="taxa-save-btn" @click="salvar">
            <v-icon left color="white" size="20">save</v-icon>
            Salvar Alterações
          </button>
        </v-flex>
      </v-layout>

      <!-- Loading -->
      <v-layout justify-center align-center v-else style="min-height: 200px;">
        <div class="taxa-loading-wrap">
          <v-progress-circular indeterminate :size="60" :width="5" color="primary"></v-progress-circular>
          <p class="taxa-loading-text">Carregando configurações...</p>
        </div>
      </v-layout>
    </v-card-text>

    <!-- Dialog de Confirmação -->
    <v-dialog v-model="dialog_confirmacao" max-width="450">
      <v-card style="border-radius: 12px; overflow: hidden;">
        <v-card-title class="headline pb-2" style="color: #1976D2; font-weight: 700;">Confirmar Alterações</v-card-title>
        <v-card-text class="pt-0 grey--text text--darken-2" style="font-size: 1rem;">
          Tem certeza que deseja salvar as alterações nas taxas de serviço?
        </v-card-text>
        <v-card-actions class="pa-3" style="background: #fafbfc; border-top: 1px solid #eef0f4;">
          <v-spacer></v-spacer>
          <v-btn flat color="grey darken-1" @click="dialog_confirmacao = false" style="font-weight: 600;">Cancelar</v-btn>
          <v-btn color="primary" @click="confirmarSalvar" style="border-radius: 6px; font-weight: 600;">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'
import firebaseDao from '@/api/firebase/index.js'

export default {
  directives: { money: VMoney },
  data: () => ({
    taxas: [],
    money: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false
    },
    moneyPercent: {
      decimal: ',',
      thousands: '.',
      precision: 2,
      masked: false
    },
    carregando: false,
    dialog_confirmacao: false
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    formatToMoney (value) {
      if (!value) return '0,00'
      const number = parseFloat(value).toFixed(2)
      return number.replace('.', ',')
    },
    parseMoney (value) {
      if (!value) return null
      return value.replace(/\./g, '').replace(',', '.')
    },
    salvar () {
      this.dialog_confirmacao = true
    },
    async confirmarSalvar () {
      this.dialog_confirmacao = false
      this.carregando = true
      let hasError = false
      for (const taxa of this.taxas) {
        const payload = {
          ativa: taxa.ativa,
          em_percentual: taxa.em_percentual,
          valor: this.parseMoney(taxa.valor_formatado),
          tipo_cobranca: taxa.tipo_cobranca || 1
        }
        if (taxa.firebase !== undefined && taxa.firebase !== null) {
          payload.firebase = taxa.firebase
        }
        try {
          if (taxa.id) {
            payload.id = taxa.id
            await this.$store.dispatch('atualizarTaxaServico', payload)
          } else if (taxa.ativa) {
            await this.$store.dispatch('criarTaxaServico', payload)
          }
        } catch (e) {
          hasError = true
          console.error(e)
        }
      }
      this.carregando = false
      if (hasError) {
        this.$emit('error', 'Erro ao tentar atualizar algumas taxas.')
      } else {
        this.$emit('success', 'As taxas foram atualizadas com sucesso!')
        this.listarTaxas()
      }
    },
    async listarTaxas () {
      this.carregando = true
      try {
        const [resTaxas, resFirebases] = await Promise.all([
          this.$store.dispatch('listarTaxasServico').catch(() => []),
          firebaseDao.gerenciar(this.$store.state.headers, null, 'GET')
            .then(res => res.ok ? res.json() : []).catch(() => [])
        ])

        // Garante que são arrays (lidando com paginação ou undefined)
        const taxasArr = Array.isArray(resTaxas) ? resTaxas : (resTaxas && resTaxas.results ? resTaxas.results : [])
        const firebasesArr = Array.isArray(resFirebases) ? resFirebases : (resFirebases && resFirebases.results ? resFirebases.results : [])

        const novasTaxas = []

        // Global Apetrus
        const taxaGlobal = taxasArr.find(t => !t.firebase)
        novasTaxas.push({
          id: taxaGlobal ? taxaGlobal.id : null,
          firebase: null,
          nome_rede: 'Apetrus',
          ativa: taxaGlobal ? taxaGlobal.ativa : false,
          em_percentual: taxaGlobal ? taxaGlobal.em_percentual : false,
          tipo_cobranca: taxaGlobal && taxaGlobal.tipo_cobranca ? taxaGlobal.tipo_cobranca : 1,
          valor_formatado: this.formatToMoney(taxaGlobal ? taxaGlobal.valor : 0)
        })

        // Firebases com Rede
        const firebasesComRede = firebasesArr.filter(f => !!f.rede)
        for (const firebase of firebasesComRede) {
          const taxaRede = taxasArr.find(t => t.firebase === firebase.id)
          novasTaxas.push({
             id: taxaRede ? taxaRede.id : null,
             firebase: firebase.id,
             nome_rede: `Aplicativo ${firebase.nome_rede || firebase.codigo}`,
             ativa: taxaRede ? taxaRede.ativa : false,
             em_percentual: taxaRede ? taxaRede.em_percentual : false,
             tipo_cobranca: taxaRede && taxaRede.tipo_cobranca ? taxaRede.tipo_cobranca : 1,
             valor_formatado: this.formatToMoney(taxaRede ? taxaRede.valor : 0)
          })
        }

        this.taxas = novasTaxas
      } catch (e) {
        console.error('Erro ao buscar dados.', e)
      }
      this.carregando = false
    }
  },
  mounted () {
    this.listarTaxas()
  }
}
</script>

<style scoped>
/* ===== Card principal ===== */
.taxa-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.12) !important;
}

/* ===== Header com gradiente ===== */
.taxa-dialog-header {
  background: linear-gradient(135deg, #1565C0 0%, #1976D2 60%, #42A5F5 100%);
  padding: 14px 20px 16px;
  position: relative;
  text-align: center;
}

.taxa-close-btn {
  position: absolute !important;
  top: 8px;
  left: 8px;
  opacity: 0.85;
  transition: opacity 0.2s;
}

.taxa-close-btn:hover {
  opacity: 1;
}

.taxa-header-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.taxa-header-icon {
  font-size: 24px !important;
  color: rgba(255, 255, 255, 0.9) !important;
  margin-bottom: 0;
}

.taxa-header-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  letter-spacing: 0.02em;
}

.taxa-header-subtitle {
  display: none;
}

/* ===== Corpo do card ===== */
.taxa-card-body {
  padding: 24px 20px 20px !important;
  background: #f5f7fa;
}

/* ===== Card de taxa ===== */
.taxa-item-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1.5px solid #e8eaf0;
  margin-bottom: 16px;
  overflow: hidden;
  transition: border-color 0.25s, box-shadow 0.25s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.taxa-item-card--active {
  border-color: #1976D2;
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.12);
}

.taxa-item-card--active .taxa-item-header {
  background: linear-gradient(90deg, #e3f0fd 0%, #f0f7ff 100%);
}

/* ===== Cabeçalho do card ===== */
.taxa-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: #fafbfc;
  border-bottom: 1px solid #eef0f4;
  transition: background 0.25s;
}

.taxa-item-header-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.taxa-item-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #e3f0fd;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.taxa-item-name {
  font-size: 0.92rem;
  font-weight: 600;
  color: #263238;
}

/* ===== Badge de status ===== */
.taxa-status-badge {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 3px 10px;
  border-radius: 20px;
}

.taxa-status-badge--on {
  background: #e8f5e9;
  color: #2e7d32;
}

.taxa-status-badge--off {
  background: #fafafa;
  color: #9e9e9e;
  border: 1px solid #e0e0e0;
}

/* ===== Corpo do card de taxa ===== */
.taxa-item-body {
  padding: 18px 16px 20px;
}

/* ===== Toggle R$ / % ===== */
.taxa-type-toggle {
  display: inline-flex;
  width: fit-content;
  border-radius: 8px;
  overflow: hidden;
  border: 1.5px solid #cfd8dc;
  background: #f5f7fa;
}

.taxa-type-btn {
  width: 56px;
  height: 38px;
  border: none;
  background: transparent;
  font-size: 0.9rem;
  font-weight: 600;
  color: #607d8b;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  outline: none;
}

.taxa-type-btn:hover {
  background: #e3f2fd;
  color: #1565C0;
}

.taxa-type-btn--active {
  background: #1976D2;
  color: #ffffff;
  border-radius: 6px;
}

/* ===== Campos do formulário ===== */
.taxa-text-field,
.taxa-select {
  border-radius: 8px;
}

.taxa-text-field >>> .v-input__slot,
.taxa-select >>> .v-input__slot {
  border: 1px solid #cbd2da !important;
  border-radius: 8px !important;
}

.taxa-text-field >>> .v-input__slot:hover,
.taxa-select >>> .v-input__slot:hover {
  border-color: #1976D2 !important;
}

/* ===== Botão salvar ===== */
.taxa-save-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #1565C0 0%, #1976D2 100%);
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s, opacity 0.15s;
  box-shadow: 0 4px 16px rgba(25, 118, 210, 0.35);
  outline: none;
}

.taxa-save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.42);
}

.taxa-save-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.3);
}

/* ===== Loading ===== */
.taxa-loading-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.taxa-loading-text {
  font-size: 0.9rem;
  color: #78909c;
  margin: 0;
}
</style>
